import React from 'react';
import './PortfolioSection.css';
import PortfolioItem from './PortfolioItem';

function PortfolioSection({ items }) {
  return (
    <section id="portfolio" className="portfolio">
      <div className="portfolio-header">
        <h2 className="section-title">Portfolio</h2>
        <p className="portfolio-intro">
          Real examples of AI evaluation, reasoning analysis, and content improvement. 
          Each sample demonstrates systematic approaches that improve model accuracy and reliability.
        </p>
      </div>
      <div className="portfolio-grid">
        {items.map(item => (
          <PortfolioItem key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}

export default PortfolioSection;

